// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - OFFERS ||============================== //

export async function handleOffers(action: APIAction) {
  switch (action.method) {
    case 'read':
      return getRequest(`/offers?agent-id=${action.id}`);
    case 'read-developments':
      return postRequest(`/offers/developments?agent-id=${action.id}`, action.data);
    case 'create':
      return postRequest('/offers', action.data);
    case 'update':
      return putRequest(`/offers/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/offers/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleOffers] - Unknown method');
      break;
  }
}
